import {
  AssetsProvider,
  notDesktop,
  obvioEnv,
  styled,
  useContextPath,
} from '@obvio/app'
import { ProductHeroView, AgeRestrictionModal } from '@obvio/template'

import { useProfitRoom } from '../useProfitRoom'

import type { Schema } from '@obvio/app'
import type { DeepPick } from '@obvio/utils'
import type { ReactElement } from 'react'

const StyledProductHero = styled(ProductHeroView)`
  color: ${(theme) => theme.colors.secondary};

  @media ${notDesktop} {
    border: none;
  }
`

export type HeroProduct = DeepPick<
  Schema['Product'],
  {
    id: true
    slug: true
    title: true
    description: true
    seoTitle: true
    seoDescription: true
    trackInventory: true
    ageRestriction: true
    variants: {
      id: true
      inventory: true
      price: {
        sale: true
        price: {
          amount: true
        }
      }
      regularPrice: {
        sale: true
        price: {
          amount: true
        }
      }
      lowestPriceBeforeSale: {
        sale: true
        price: {
          amount: true
        }
      }
      attributes: {
        id: true
        value: true
        attribute: {
          id: true
          title: true
        }
      }
    }
    images: true
    category: {
      title: true
      ageRestriction: true
    }
    attributes: {
      id: true
      title: true
      values: {
        id: true
        value: true
      }
      static: true
    }
    price: {
      price: true
      lowestPriceBeforeSale: true
      regularPrice: true
      otherPrices: true
      currency: true
    }
  }
>

export type StoreProductHeroProps = {
  product?: HeroProduct | undefined
  className?: string | undefined
}

export function StoreProductHero({
  product,
  className,
}: StoreProductHeroProps): ReactElement {
  //   const { t } = useTranslation()
  const { vouchersOpen } = useProfitRoom()
  const contextPath = useContextPath('ecommerce.product')
  const { description, variants, images, slug, ageRestriction, ...rest } =
    product ?? {}

  return (
    <AssetsProvider path={`${contextPath}/${product?.id ?? ''}`}>
      <StyledProductHero
        noLabels
        galleryOptions={{ position: 'center' }}
        className={className}
        description={description}
        variants={variants ?? []}
        images={images}
        product={'id' in rest ? rest : undefined}
        contactMail={obvioEnv().OBVIO_PUBLIC_CONTACT_EMAIL}
        fallbackText="Kup voucher"
        onFallbackClick={vouchersOpen}
        attributes={product?.attributes}
      />
      <AgeRestrictionModal
        age={ageRestriction ?? product?.category?.ageRestriction}
      />
    </AssetsProvider>
  )
}
